import { useState } from 'react'
import type { TIconProps } from '~/components/icon'
import type { ChipsSizes } from '../chips.types'

export function UseChips() {
  const [selectedValue, setSelectedValue] = useState('')
  const iconSizeMapping: Record<ChipsSizes, TIconProps['size']> = {
    sm: 'extra-small',
    md: 'extra-small',
    ml: 'small',
  }

  return {
    selectedValue,
    setSelectedValue,
    iconSizeMapping,
  }
}
